var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex flex-row cursor-pointer",on:{"click":_vm.sort}},[_c('div',[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"ml-2 d-flex flex-column chevrons",staticStyle:{"margin-top":"3px"}},[_c('div',{staticClass:"mt-n1 mb-n1"},[_c('i',{staticClass:"fas fa-angle-up",class:{
                'text-muted opacity-25': !_vm.sortActive || _vm.sortDirection !== 'asc',
                'text-primary': _vm.sortActive && _vm.sortDirection === 'asc'
            }})]),_vm._v(" "),_c('div',{staticClass:"mb-n2",staticStyle:{"margin-top":"-1px"}},[_c('i',{staticClass:"fas fa-angle-down",class:{
                'text-muted opacity-25': !_vm.sortActive || _vm.sortDirection !== 'desc',
                'text-primary': _vm.sortActive && _vm.sortDirection === 'desc'
                }})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }